<template>
  <div>
    <div class="px-4 py-1">
      <vetster-checkbox-input
        v-for="gender in petGenderOptions"
        :key="gender.value"
        v-model="value.gender"
        :value="gender.value"
        :label="gender.text"
        type="radio"
      />
    </div>
    <div
      v-if="showSpayedNeuteredOptions"
      class="mt-10 px-4 py-1"
    >
      <p class="text-2xl font-title leading-6 font-medium text-neutral-900">
        {{ getSpayedNeuteredLabel }}
      </p>
      <vetster-checkbox-input
        v-for="option in yesNoOptions"
        :key="option.value"
        v-model="value.spayed_neutered"
        :value="option.value"
        :label="option.text"
        type="radio"
      />
    </div>
  </div>
</template>

<script>
import VetsterCheckboxInput from '@/brand-components/VetsterCheckboxInput';
import useFormHelpers from '@/composables/use-form-helpers';
import Gender from '@/enums/Gender';

export default {
  name: 'VetsterGenderForm',

  components: { VetsterCheckboxInput },

  props: {
    formInputs: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const {
      petGenderOptions,
      yesNoOptions,
    } = useFormHelpers();

    return {
      petGenderOptions,
      yesNoOptions,
    };
  },

  data() {
    return {
      value: { ...this.formInputs },
    };
  },

  computed: {
    showSpayedNeuteredOptions() {
      return !!this.value.gender;
    },
    getSpayedNeuteredLabel() {
      switch (this.value.gender) {
        case Gender.Female:
          return this.$t('pets.is-your-pet-spayed');
        case Gender.Male:
          return this.$t('pets.is-your-pet-neutered');
        default:
          return this.$t('pets.is-your-pet-spayed');
      }
    },
  },

  watch: {
    value: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
  },

  created() {
    this.value.spayed_neutered = this.value.spayed_neutered || false;
  },
};
</script>
